



























































































import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import style from './style.module.scss'
import config from '../../../../config'

import notice from '@/components/common/info/notice/notice.vue'
import buttonRed from '@/components/common/click/button/button-red.vue'
import loader from '@/components/common/loader/loader.vue'
import overlay from '@/components/common/loader/overlay.vue'
import numberInput from '@/components/controls/number-input/number-input.vue'

import attributesList from './attributes/attributes-list.vue'
import productInfo from './product-info/product-info.vue'
import bindingToProject from './binding-to-project/binding-to-project.vue'
import unitSelector from './unit-selector/unit-selector.vue'
import okpd2Selector from './okpd2-selector/okpd2-selector.vue'
import okved2Selector from './okved2-selector/okved2-selector.vue'

import budget from './budget/budget.vue'

import { Project, ProductMainInfo, ProjectItem, ProductCharacteristic, FieldErrorModel } from '@/types/supplier-search'
import {UnitsModel, Okpd2Model, Okved2Model, ValidationData} from '@/types/common'
import {DefaultListModel} from "@/components/controls/select/select-searchable/types";
import { yandexMetrika } from '../../supplier-search/yandex-metrika-mixin';

export default Vue.extend({
    name: 'supplier-search-step-one',
    mixins: [yandexMetrika],
    components: {
        notice,
        buttonRed,
        numberInput,
        attributesList,
        productInfo,
        bindingToProject,
        unitSelector,
        okpd2Selector,
        loader,
        overlay,
        budget,
    },
    mounted() {
        this.$root.$on('loadingOkpd2', function(this: any, state: boolean) {
            this.okpdLoading = state;
        }.bind(this));

        this.$root.$on('clearFilledCodes', () => {
            this.currentPosition.Okpd2 = '';
            this.currentPosition.Okpd2Name = '';
            this.currentPosition.Okved2 = '';
            this.currentPosition.Okved2Name = '';
        });
        this.$root.$on('clearInitRendering', () => {
            this.initRendering = false;
        })

        this.$root.$on('clearPositionPriceAndBudget', () => {
            this.startBudget = 0;
            this.startPrice = 0;
            this.$store.dispatch('clearCurrentPositionPriceAndBudget');
        });

        this.startBudget = this.budget;
        this.startPrice = this.price;
    },
    data() {
        return {
            config: config,
            style: style,
            propsfromRegistry: false,
            selectorIsOpen: false,
            selectorOkpd2IsOpen: false,
            selectorOkved2IsOpen: false,
            loading: false,
            okpdLoading: false,
            initRendering: false,
            positionNameError: {
                error: false,
                message: ''
            } as FieldErrorModel,
            budgetError: {
                error: false,
                message: ''
            } as FieldErrorModel,
            okpd2Error: {
                error: false,
                message: ''
            } as FieldErrorModel,
            okved2Error: {
                error: false,
                message: ''
            } as FieldErrorModel,
            unitError: {
                error: false,
                message: "",
            } as FieldErrorModel,
            withoutPrice: false,
            startPrice: 0,
            startBudget: 0,
        }
    },
    methods: {
        ...mapActions("suppliers", {
            loadAiServiceSuggestions: "loadAiServiceSuggestions",
        }),
        unitSelectorToggle(isOpen: boolean): void {
            this.selectorIsOpen = isOpen
        },
        forward() {

            if(!this.validate()) {
                return;
            }
            (this as any).sendToYandexMetrikaTtSendTwoStep();
            this.$emit('forward')
        },
        selectOkpd2(data: Okpd2Model) {
            this.$store.commit('setOkpd2', data);
        },
        okpd2SelectorToggle(isOpen: boolean): void {
            this.selectorOkpd2IsOpen = isOpen
        },
        async sendProject() {

            if(!this.validate()) {
                return;
            }

            if (!this.isAuthentificated) {
                this.$emit('forward');
            }
            else {
                this.selectUnit(this.unitValue);
                this.loading = true;
                await this.$store.dispatch('updateProject')
                this.loading = false;
                this.$store.dispatch('getProjectsInfo')
                this.$emit('saved');
                this.emitSentEvent();
                this.resetBudget();
            }
        },
        validate() {
            if(!this.currentPosition.Price && !this.currentPosition.WithoutPrice) {
                this.budgetError.error = true;
                this.budgetError.message = 'Цена должна быть больше нуля'
                return false
            }
            if(!this.currentPosition.Name) {
                this.positionNameError.error = true;
                this.positionNameError.message = 'Поле должно быть заполнено'
                return false
            }
            if (!this.currentPosition.Okpd2 || !this.currentPosition.Okpd2Name){
                this.okpd2Error.error = true;
                this.okpd2Error.message = 'ОКПД2 дожен быть указан';
                return false;
            }
            if (!this.currentPosition.UnitCode && !this.aiServiceOptionsResult.code) {
                this.unitError.error = true;
                this.unitError.message = "Поле должно быть заполнено";
                return false;
            }
            return true;
        },
        groupSelect(data: { group: Project; item: ProjectItem }) {
            this.$store.dispatch('updateCurrentProject', data.group);

            const price = (data && data.item && data.item.Price) ? data.item.Price : 0;
            const budget = (data && data.item && data.item.Amount && data.item.Amount > 0) ? price * data.item.Amount : 0;

            this.startPrice = price;
            this.startBudget = budget;

            if (data.item.Okpd2 && data.item.Okpd2Name && data.item.Okpd2.length > 0 && data.item.Okpd2Name.length > 0) {
                const okpd2 = data.item.Okpd2 + ' ' + data.item.Okpd2Name;
                this.$root.$emit('getCodesSuggestion', okpd2);
            }
        },
        parseFloat(value: string): number {
            const decimal = parseFloat(value)
            return isNaN(decimal) ? this.NaNWarn(value) : decimal;
        },
        NaNWarn(nanValue: string): number {
            return 0;
        },
        copyCharacteristicsFromProduct() {
            //копируем характиристики из витрины в текущую позицию
            this.$store.dispatch('copyCharacteristicsToPosition');
        },
        selectUnit(data: UnitsModel) {
            this.$store.commit('setPositionUnit', data);
        },
        emitSentEvent() {
            if (window.supplierSearchEventBus) {
                window.supplierSearchEventBus.$emit('requestSent');
            }
        },
        resetBudget() {
            this.$store.dispatch('setCurrentPositionPrice', 0);
            this.$store.dispatch('setCurrentPositionBudget', 0);
        },
    },
    computed: {
        ...(mapState<RootStateSupplierSearch>({
            mainProductinfo(state: RootStateSupplierSearch): ProductMainInfo {
                return state.mainProductinfo
            },
            currentProject(state: RootStateSupplierSearch): Project {
                return state.currentProject;
            },
            currentPosition(state: RootStateSupplierSearch): ProjectItem {
                return state.currentPosition;
            },
            supplierOrganization(state: RootStateSupplierSearch) {
                return state.supplierOrganization
            },
            isNewProject(state: RootStateSupplierSearch) {
                return state.isNewProject;
            },
            isNewPosition(state: RootStateSupplierSearch) {
                return state.isNewPosition;
            }
        }) as MapStateToComputed<RootStateSupplierSearch>),
        notOriginMode(): boolean {
            return this.$store.getters.notOriginModeType;
        },
        ...mapState("suppliers", {
            aiServiceOptionsResult: "aiServiceOptionsResult"
        }),
        okpd2Value(): Okpd2Model {
            const okpd2Value: Okpd2Model = {
                Name: this.currentPosition.Okpd2Name,
                Code: this.currentPosition.Okpd2,
            }
            return okpd2Value;
        },
        okved2Value(): Okved2Model {
            const okved2Value: Okved2Model = {
                Name: this.currentPosition.Okved2Name,
                Code: this.currentPosition.Okved2
            }
            return okved2Value;
        },
        positionAmount: {
            get(): number {
                return this.$store.state.currentPosition.Amount;
            },
            set(value: number): void {
                if(!value) {
                    this.$store.commit('setPositionAmount', 1);
                    return
                }
                this.$store.commit('setPositionAmount', value);
            }
        },
        hasAnyProject(): boolean {
            return this.$store.getters.hasAnyProjects;
        },
        projects(): Project[] {
            return this.$store.getters.projectsForSelect;
        },
        characteristicsForDisplay(): ProductCharacteristic[] {
            return [...this.$store.getters.characteristicsForDisplay];
        },
        isAuthentificated(): boolean {
            return this.$store.getters.isAuthentificated;
        },
        unitValue(): UnitsModel {
            const unitValue: UnitsModel = {
                UnitShortName: this.currentPosition.UnitShortName,
                UnitName: this.currentPosition.UnitName,
                UnitCode: this.currentPosition.UnitCode
            }

            if(!unitValue.UnitCode && !unitValue.UnitName && !unitValue.UnitShortName){
                unitValue.UnitName = this.aiServiceOptionsResult.fullName,
                unitValue.UnitCode = this.aiServiceOptionsResult.code,
                unitValue.UnitShortName = this.aiServiceOptionsResult.name
            }

            return unitValue;
        },
        budget(): number {
            return this.$store.state.currentPosition.Budget != null ? this.$store.state.currentPosition.Budget : 0;
        },
        price(): number {
            return this.$store.state.currentPosition.Price != null ? this.$store.state.currentPosition.Price : 0;
        }
    },
    watch: {
        'currentPosition.Name'(): void {
            if(this.currentPosition.Name) {
                if (this.isNewPosition && !this.initRendering) {
                    this.initRendering = true;
                    if (this.currentPosition.Name.length > 2)
                    this.$root.$emit('getCodesSuggestion', this.currentPosition.Name);
                }
                this.positionNameError.error = false;
                this.positionNameError.message = ''
            }
        },
        "currentPosition.UnitCode"() {
            if (this.currentPosition.UnitCode) {
                this.unitError.error = false;
                this.unitError.message = "";
            }
        },
        "okpd2Value"(){
            if (!this.currentPosition.UnitCode) {
                this.loadAiServiceSuggestions({subject: this.okpd2Value.Code, autocompleteCodeType: 2});
            }
            if (this.currentPosition.Okpd2 && this.currentPosition.Okpd2Name){
                this.okpd2Error.error = false;
                this.okpd2Error.message = '';
            }
        }
    }
})
